import { ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const getGeneralOptions = ({ queryKey: [endpoint] }) =>
  axiosAuth.get(`${ENDPOINT_ROOT}/${endpoint}`).then((res) => res.data);

export default getGeneralOptions;
